var map = {
	"./adult/audio.mp3": 7425,
	"./confidence/audio.mp3": 3205,
	"./couples/audio.mp3": 1790,
	"./nice/audio.mp3": 1378,
	"./psycho/audio.mp3": 9749,
	"./quirky/audio.mp3": 5430,
	"./rude/audio.mp3": 1275,
	"./sex/audio.mp3": 825,
	"./spicy-couple/audio.mp3": 1750,
	"./spicy/audio.mp3": 8823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2752;